import axios from 'axios'

const API_BASE_URL = import.meta.env.VITE_API_URL || '/api'

const api = axios.create({
  baseURL: API_BASE_URL,
})

// Add token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

export interface AccommodationEvent {
  _id: string
  student: {
    _id: string
    firstName: string
    lastName: string
  }
  teacher: {
    _id: string
    firstName: string
    lastName: string
  }
  class: {
    _id: string
    name: string
  }
  accommodation: string
  status: string
  date: string
  notes?: string
  createdAt: string
  updatedAt: string
}

export interface CreateAccommodationEventsRequest {
  studentId: string
  classId: string
  date?: Date
  accommodationStatuses: Record<string, string>
  notes?: string
}

export interface UpdateAccommodationEventRequest {
  status: string
  notes?: string
}

// Get accommodation events for a specific student and class on a specific date
export const getAccommodationEvents = async (
  studentId: string,
  classId: string,
  date?: Date,
): Promise<AccommodationEvent[]> => {
  const params = new URLSearchParams({
    studentId,
    classId,
  })

  if (date) {
    params.append('date', date.toISOString())
  }

  const response = await api.get(`/accommodation-events?${params.toString()}`)
  return response.data.data
}

// Get all accommodation events for the authenticated user's classes
export const getAllAccommodationEvents = async (): Promise<
  AccommodationEvent[]
> => {
  const response = await api.get('/accommodation-events/all')
  return response.data.data
}

// Create or update accommodation events for a student
export const createAccommodationEvents = async (
  data: CreateAccommodationEventsRequest,
): Promise<AccommodationEvent[]> => {
  const response = await api.post('/accommodation-events', data)
  return response.data.data
}

// Update a specific accommodation event
export const updateAccommodationEvent = async (
  id: string,
  data: UpdateAccommodationEventRequest,
): Promise<AccommodationEvent> => {
  const response = await api.put(`/accommodation-events/${id}`, data)
  return response.data.data
}

// Delete a specific accommodation event
export const deleteAccommodationEvent = async (id: string): Promise<void> => {
  await api.delete(`/accommodation-events/${id}`)
}
